'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchNoble = undefined;
exports.matchTextInEventResults = matchTextInEventResults;
exports.matchBibInEventResults = matchBibInEventResults;

var _ResultsNoble = require('./ResultsNoble');

////////////////////////////////////////////////////////////////
// Search Event Results.

function matchTextInEventResults(_ref) {
  var eventId = _ref.eventId;
  var searchText = _ref.searchText;
  var topN = _ref.topN;

  return _ResultsNoble.ResultsNoble.matchTextInEventResults.apply(_ResultsNoble.ResultsNoble, arguments);
}

function matchBibInEventResults(_ref2) {
  var eventId = _ref2.eventId;
  var bibNumber = _ref2.bibNumber;

  return _ResultsNoble.ResultsNoble.matchBibInEventResults.apply(_ResultsNoble.ResultsNoble, arguments);
}

// For testing.
var SearchNoble = exports.SearchNoble = {
  matchTextInEventResults: matchTextInEventResults,
  matchBibInEventResults: matchBibInEventResults
};


//////////////////
// WEBPACK FOOTER
// ../~/anuket/lib/nobles/SearchNoble.js
// module id = 427
// module chunks = 0